import moment from 'moment';
import {
  purchaseHistoryTableColumns,
  purchaseHistoryTableColumnsClient,
} from '../../../constants/tableColumns';
import { useAuthContext } from '../../../contexts/AuthProvider';
import usePurchaseActions from '../../../hooks/APIHooks/finance/usePurchaseActions';
import { showTimeIn12HrsFormat } from '../../../utils/timeAndDate';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../../CommonComps/Tables/AcademiaTable';
import PageHeader from '../../CommonComps/Titles/PageHeader';

const ShowAllPurchaseHistory = () => {
  // integration of context API hooks here
  const { currentUserType } = useAuthContext();

  // integration of custom API hooks here
  const { getPaymentInfoListHandler } = usePurchaseActions('paymentInfoList');

  console.log('PURCHASE HISTORY LIST: ', getPaymentInfoListHandler.data?.data);

  // rendering show all purchase history section component here
  return (
    <>
      {getPaymentInfoListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getPaymentInfoListHandler.isSuccess ? (
        <section>
          <PageHeader headerText='Purchase History' />

          <AcademiaTable
            data={
              getPaymentInfoListHandler.data.data?.map((purchase) => ({
                ...purchase,
                date: moment(purchase.date).format('DD-MM-YYYY'),
                start_time: showTimeIn12HrsFormat(purchase.start_time),
                end_time: showTimeIn12HrsFormat(purchase.end_time),
              })) || []
            }
            columns={
              currentUserType === 'client'
                ? purchaseHistoryTableColumnsClient
                : purchaseHistoryTableColumns
            }
            notFoundMessage='No purchase history found!'
          />
        </section>
      ) : getPaymentInfoListHandler.isError ? (
        <AcademiaNotFound message='Failed to load purchase history data!!' />
      ) : null}
    </>
  );
};

export default ShowAllPurchaseHistory;
